module.exports = __webpack_public_path__ + "img/HZ-T1542.55ddc907.jpg";